// extracted by mini-css-extract-plugin
module.exports = {"DesktopHeader__primaryLinks":"styles_DesktopHeader__primaryLinks__zd8GA"};